import { render } from "./EventCardPlaceholder.vue?vue&type=template&id=0bdd54ba&scoped=true&ts=true"
import script from "./EventCardPlaceholder.vue?vue&type=script&lang=ts"
export * from "./EventCardPlaceholder.vue?vue&type=script&lang=ts"

import "./EventCardPlaceholder.vue?vue&type=style&index=0&id=0bdd54ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdd54ba"]])

export default __exports__